export default "__VITE_ASSET__351f86d6__"